import { Component, OnInit } from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {FormArray, FormGroup} from '@angular/forms';
import {WaitForCallback, WaitForCallbackForm} from './waitForCallback';
import { newStepValue } from "../../../../../services/flowBuilder/utils/constants";

const NODE_TYPE = 'waitForCallback';

@Component({
  selector: 'app-wait-for-callback',
  templateUrl: './wait-for-callback.component.html',
  styleUrls: ['./wait-for-callback.component.scss']
})
export class WaitForCallbackComponent extends NodeBuilder implements OnInit {

  actionParams: FormGroup = undefined;
  actionResults: FormArray = undefined;
  actionDefaultResults: FormArray = undefined;
  stepUniqueID: string = '';

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    const waitForCallbackFormType = WaitForCallback.toForm(stepData, this.canEdit);
    this.actionParams = waitForCallbackFormType.actionParams;
    this.actionResults = waitForCallbackFormType.actionResults;
    this.actionDefaultResults = waitForCallbackFormType.actionDefaultResults;

    // Patching Default Results so that the next step selector has the correct steps set.
    this.patchDefaultActionResult('0.next');
    this.patchDefaultActionResult('1.next');
  }

  get getStepData(): {} {
    const stepData = new WaitForCallback(NODE_TYPE);
    stepData.addActionParams(this.actionParams.getRawValue());
    stepData.addResults(this.actionDefaultResults.getRawValue());
    stepData.addResults(this.actionResults.getRawValue());
    let nodeData = stepData.nodeData;
    if(this.stepUniqueID !== '') {
      nodeData['metadata'].stepUniqueID = this.stepUniqueID;
    }
    return nodeData;
  }

  get isNodeValid(): boolean {
    this.actionParams.markAllAsTouched();
    this.actionResults.markAllAsTouched();
    return this.actionParams.valid && this.actionResults.valid;
  }

  patchDefaultActionResult(formControlPath: string) {
    const resultFormControl = this.actionDefaultResults.get(formControlPath);
    if (resultFormControl && resultFormControl.value === newStepValue) {
      resultFormControl.setValue('step' + this.getNextStep());
    }
  }

  addResult() {
    if (!this.canEdit) return;
    this.actionResults.push(WaitForCallbackForm.resultTemplate(this.canEdit));
  }

  deleteResult(index: number) {
    if (!this.canEdit) return;
    this.actionResults.removeAt(index);
  }
}
